import React from 'react';
import { Divider, Drawer, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import logo from '../../images/logo-hd-platform.svg';

/*
 * initial Sidebar template that only display background and logo
 * StaticSidebar and Login components are customizing Sidebar component */

const drawerWidth = 270;

export { drawerWidth };

const useStyles = makeStyles(() => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    boxShadow: '6px 0px 18px 0px rgba(0, 0, 0, 0.06)',
  },
  toolbar: {
    minHeight: 64,
    display: 'flex',
  },
  logo__accent: {
    maxHeight: 55,
    alignSelf: 'center',
    marginLeft: 13,
  },
  flexBox: {
    display: 'flex',
  },
}));

const Sidebar = ({ children }) => {
  const classes = useStyles();

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <div className={classes.toolbar}>
        <img className={classes.logo__accent} src={logo} alt="hd platform logo" />
      </div>
      <Divider />
      {children}
    </Drawer>
  );
};

Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Sidebar;
